var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { OutlineEntityDotLink } from './outline-entity-dot-link';
var cls = classNames('entity-dot-link-items');
export var EntityDotLinkItemsDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var OutlineDotLinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  OutlineDotLink: styled(OutlineEntityDotLink)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), OutlineDotLinkStyles)
  // SubLevelDotLink: styled(SubTopic)`${ItemStyles}`,
};
export var EntityDotLinkItems = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items,
    rest = __rest(props, ["className", "children", "items"]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (item) {
    var outline = (item === null || item === void 0 ? void 0 : item.outlineNumber) ? String(item.outlineNumber) : '';
    var part = outline.split('.');
    var dotProps = __assign(__assign({}, rest.dotProps || {}), {
      color: rest.dotProps && rest.dotProps.color || item.color && item.color.value || 'primary',
      fill: part.length <= 2 ? '' : 'FFF'
    });
    return React.createElement(My.OutlineDotLink, {
      key: item.id,
      entity: item,
      dotProps: dotProps
    });
  }), children);
};
EntityDotLinkItems.defaultProps = EntityDotLinkItemsDefaultProps;
EntityDotLinkItems.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;